module.exports = __webpack_public_path__ + "static/media/cover.e7f512b7.png";